<template>
    <div id="app" class="dashboard">
        <home-nav v-if="showHomeNav"></home-nav>
        <router-view :key="$route.fullPath" />
    </div>
</template>

<script>
    import dashboardNav from './views/dashboard/DashboardNav.vue';
    export default {
        components: { 'home-nav': dashboardNav },

        created() {
            // Disable the mouse right click event
            window.document.oncontextmenu = function () {
                return false;
            };
        },
        computed: {
            showHomeNav() {
                // Show nav-bar only for Dashboard
                return (
                    !this.$route.fullPath.toLowerCase().startsWith('/mobile') &&
                    !this.$route.fullPath.toLowerCase().startsWith('/portal') &&
                    !this.$route.fullPath.toLowerCase().startsWith('/web') &&
                    !this.$route.fullPath.toLowerCase().startsWith('/conditions') &&
                    !this.$route.fullPath.toLowerCase().startsWith('/securedurl') &&
                    !this.$route.fullPath.toLowerCase().startsWith('/error/') &&
                    this.$route.fullPath !== '/'
                );
            }
        }
    };
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
</style>
